import FilterFileEditor from './FilterFileEditor'
export default FilterFileEditor;